import React, { useEffect } from 'react';
import { useAppSelector } from './hooks';
import { useSaveProjectStateMutation } from './api/GraphAPI';
import { toaster } from '@/components/ui/toaster';
export default function AutoSaver() {
  const state = useAppSelector((state) => state.viewReducer);

  const [saveView, { isError, error }] = useSaveProjectStateMutation();

  const timeoutRef = React.useRef<number | null>(null);

  useEffect(() => {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
    }
    const newTimeout = window.setTimeout(() => {
      if (state.isAutosaveActive) {
        saveView(state);
      }
      console.log('AutoSaver', 'Saving', state.isAutosaveActive);
    }, 5000);
    timeoutRef.current = newTimeout;
  }, [state, saveView]);

  useEffect(() => {
    if (isError) {
      toaster.create({
        title: 'Error while autosaving project',
        description: `Something went wrong while querying the MySQL DB: ${error}`,
        status: 'error',
        duration: null,
        isClosable: true,
      });
    }
  }, [isError, error]);

  return null;
}
